export const styles = {
  padding: "13px 1em",
  margin: 0,
};
